import { ValidationMessageType } from '@sdbn/appclient';
import { ValidationMessage } from '@sdbn/appclient';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { HttpService } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { TerminalTransportRegistration, TerminalTransportRegistrationResult } from 'src/tmc-yard/model/terminal/transport-registration.model';
import { BarcodeScan } from 'src/tmc-common/model/terminal.model';

export class TransportRegistrationWithBarcodeController extends AbstractStepController {

    httpService: HttpService;

    constructor() {
      super();
      this.httpService = WizardServiceLocator.injector.get(HttpService);
    }

    onContextChange(contextChange: ContextChange) {

    }

    onRegisterToDashboardContext() {

    }

    private validateRegistrationCodeAndGetTransportData() {
        const barcodeScan = new BarcodeScan({value: this.dashboardContext.getContextValue('barcodeScanned')});
        this.httpService.postWithContext(environment.registrationTransportWithBarcodeEndpoint, barcodeScan )
                        .toPromise().then((response: TerminalTransportRegistrationResult) => {

          this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
          this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
          if (response.status !== ResponseStatus.FAILED) {

              const registration = new TerminalTransportRegistration(response);

              this.dashboardContext.setContextValue(TerminalContextConstants.carrier, registration.carrier);
              this.dashboardContext.setContextValue(TerminalContextConstants.supplier, registration.supplier);
              this.dashboardContext.setContextValue(TerminalContextConstants.driver, registration.driver);
              this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, registration.coDriver);
              this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
              this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, registration.trailerNumberPlate);
              this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, registration.orderReference);
              this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
              this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
              this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, registration.selectedOptions);
              this.dashboardContext.setContextValue(TerminalContextConstants.phoneNumber, registration.phoneNumber);
              this.dashboardContext.setContextValue('string1', registration.string1);
              this.dashboardContext.setContextValue('string2', registration.string2);
              this.wizardComponent.next('transport-registration-masterdata');
          } else {
            const validationMessages = new Array<ValidationMessage>();
            for (const responseMessage of response.responseMessages) {
              validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
            }
            this.dashboardContext.setContextValue('validationMessages', validationMessages);
          }
        }, error => {
            // TODO specify what happens for bad codes
        });
    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('registration code validation started');

        this.validateRegistrationCodeAndGetTransportData();

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        const previousControl = new StepControl();
        previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
        previousControl.type = StepControlType.BUTTON_STROKED;
        previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
        previousControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.previous();
        };
        controls.push(previousControl);

        let spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        spacer = new StepControl();
        spacer.type = StepControlType.SPACER;
        controls.push(spacer);

        const newRegistrationControl = new StepControl();
        newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
        newRegistrationControl.type = StepControlType.BUTTON_STROKED;
        newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
        newRegistrationControl.controlAction = () => {
            this.wizardComponent.stopInactivityMonitoring();
            this.wizardComponent.next('transport-registration-masterdata');
        };
        controls.push(newRegistrationControl);

        return controls;
    }
}
